export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/registration'
export const BASKET_ROUTE = '/basket'
export const DEVICE_ROUTE = '/device'
export const RESUME_ROUTE = '/resume'
export const HOME_ROUTE = '/'
export const SHOP_ROUTE = '/shop'